import React from "react";
import PropTypes from "prop-types";
import useErrorReporting from "./useErrorReporting";

/**
 * The purpose of this HOC is to provide reportError
 * from ErrorReportingProvider, and the reason for the abstraction
 * is so we can change our implementation of how the error
 * is reported in the future in once place.
 *
 * @export
 * @param {Component} WrappedComponent The component to wrap and enhance.
 * @return {Component} The wrapped component.
 */
const withErrorReporting = (WrappedComponent) => {
    const HocComponent = ({...props}) => {
        const {reportError, logMessage} = useErrorReporting();
        return <WrappedComponent {...props} errorReporting={{reportError, logMessage}} />;
    };

    WrappedComponent.propTypes = {
        errorReporting: PropTypes.shape({
            reportError: PropTypes.func.isRequired,
            logMessage: PropTypes.func.isRequired,
        }).isRequired,
    };

    return HocComponent;
};

export default withErrorReporting;
